function NpHttpInterceptor($rootScope, $q, alertService) {
  return {
    request(data) {
      data = data || {};

      data.headers = data.headers || [];

      return data;
    },
    responseError(response) {
      if (response.status === 401) {
        $rootScope.$emit('unauthorized');
      } else if (response.status === 403) {
        alertService.fatalError('You do not have permission to do this action/view this page');
      } else if (response.status === 408) {
        alertService.fatalError('The request timed out, please refresh');
      }

      return $q.reject(response);
    }
  };
}

NpHttpInterceptor.$inject = [
  '$rootScope',
  '$q',
  'alertService'
];

export default NpHttpInterceptor;



// WEBPACK FOOTER //
// ./src/services/httpInterceptor.js